module.exports = __webpack_public_path__ + "img/pic2.7c7e382b.png";